import { Button } from 'reactstrap';
import pdfIcon from '../../assets/images/pdf-icon.png';
import { getFileViewUrl } from 'services/fileService';

export const FilePreview = ({
  files,
  onRemove,
}: {
  files: any;
  onRemove: (index: number) => void;
}) => (
  <div className="d-flex flex-wrap mt-2">
    {files &&
      files.length > 0 &&
      files.map((file, idx) => {
        const isImage = /\.(jpg|jpeg|png|webp)$/i.test(file.url);
        const fileViewUrl = getFileViewUrl(file.url);
        return (
          <div key={idx} style={{ position: 'relative', margin: 8 }}>
            {isImage ? (
              <img
                src={fileViewUrl}
                style={{ width: 80, height: 80, objectFit: 'cover' }}
              />
            ) : (
              <a href={fileViewUrl} target="_blank" rel="noreferrer">
                <img
                  src={pdfIcon}
                  alt="PDF Icon"
                  className="img-thumbnail bg-light"
                  style={{ maxHeight: '80px', objectFit: 'contain' }}
                />
              </a>
            )}
            <Button
              color="danger"
              size="sm"
              onClick={() => onRemove(idx)}
              style={{
                position: 'absolute',
                top: -8,
                right: -8,
                borderRadius: '50%',
              }}
            >
              ×
            </Button>
          </div>
        );
      })}
  </div>
);
